var path = 'areas/shared/views/selector/match.html';
var html = "<span ng-if=\"$item.Name == null\" class=deleted uib-tooltip=\"The document referenced by this record ({{$item}}) no longer exists and should be removed before saving. Please let Octopus support know so that we can prevent this from happening in future.\"><i class=\"fa fa-warning\"></i> Missing</span> <span ng-if=\"$item.Name != null\">{{$item.Name}}</span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/views/selector/match.html
// module id = 3448463662647861
// module chunks = 1